import React from 'react';

import Page from '../../../components/Page';
import PageBody from '../../../components/PageBody';
import PageHeader from '../../../components/PageHeader';
import PageSubHeader from '../../../components/PageSubHeader';
import { RouteKey } from '../../../constants/navigation';
import ConnectedBuilderPage from '../ConnectedBuilderPage';

class AbilityScoresHelp extends React.PureComponent {
    render() {
        return (
            <Page>
                <PageBody>
                    <PageHeader>Determine Ability Scores</PageHeader>
                    <p>
                        Much of what your character does in the game depends on his or her six abilities:
                        <strong>Strength</strong>, <strong>Dexterity</strong>, <strong>Constitution</strong>,
                        <strong>Intelligence</strong>, <strong>Wisdom</strong>, and <strong>Charisma</strong>. Each
                        ability has a score, which is a number you record for use during play.
                    </p>

                    <PageHeader>Generation Method</PageHeader>
                    <p>You can determine ability scores in one of three ways, chosen in the next step:</p>

                    <PageSubHeader>Standard Array</PageSubHeader>
                    <p>
                        If you want to save time or don’t like the idea of randomly determining ability scores, you can
                        choose from a fixed list (15, 14, 13, 12, 10, 8).
                    </p>

                    <PageSubHeader>Point Buy</PageSubHeader>
                    <p>
                        Customize your ability scores by spending points. If you are playing an Adventurers League
                        character, choose this option.
                    </p>

                    <PageSubHeader>Manual</PageSubHeader>
                    <p>
                        Manually enter your ability scores. If you roll to randomly determine scores, choose this option
                        to record your results.
                    </p>
                </PageBody>
            </Page>
        );
    }
}

export default ConnectedBuilderPage(AbilityScoresHelp, RouteKey.ABILITY_SCORES_HELP);
